import { JSX, useEffect, useState } from "react";
import DataTable, { dataColumn } from "../../Generic/DataTable";
import { iDataColumn } from "../TenantAPI";

interface props {
    AllColumns: dataColumn<iDataColumn>[];
    gridData: iDataColumn[];
    onRowClick: (val: string) => void;
    selectedItem: iDataColumn;
    onFilter: (val: string) => void;
    onContextMenuClick: (val: string) => void;
}

function LeftBar(props: props) {
    return (
        <>
            <div className="filterContainer">
                <div>Filter: </div>
                <div>
                    <input
                        type="text"
                        style={{ width: "100%" }}
                        onChange={e => props.onFilter(e.currentTarget.value)}
                    />
                </div>
            </div>
            <DataTable
                data={props.gridData}
                columns={props.AllColumns}
                onRowClick={(val: string) => {
                    props.onRowClick(val);
                }}
                onRowDblClick={() => {}}
                selectedItem={props.selectedItem.id.toString()}
                uniqueIdentifiyer={x => {
                    return x.id.toString();
                }}
                contextMenuClick={props.onContextMenuClick}
            ></DataTable>
        </>
    );
}
export default LeftBar;
